import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Banner from './components/Banner';
import Differentiator from './components/Differentiator';
import BuiltDifferent from './components/BuiltDifferent';
import AIAssistant from './components/AIAssistant';
import IntegrationOptions from './components/IntegrationOptions';
import FeaturesInteractive from './components/FeaturesInteractive';
import WhyDangol from './components/WhyDangol';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Privacy from './pages/Privacy';
import PrivacyPartners from './pages/PrivacyPartners';
import Terms from './pages/Terms';
import TermsPartners from './pages/TermsPartners';
import Support from './pages/Support';
import Links from './pages/Links';
import Reach from './pages/Reach';
import About from './pages/About';
import FaqPage from './pages/Faq';
import { useScrollReveal } from './utils/useScrollReveal';
import './App.css';

// Homepage sections — header nav scrolls to these via section IDs
// (#features, #why-dangol, #faq, #contact). The /about and /faq routes
// remain accessible by direct URL for sharing or deep-linking.
const HomePage = () => {
  useScrollReveal();
  return (
    <div className="App">
      <Header />
      <Banner />
      <Differentiator />
      <BuiltDifferent />
      <FeaturesInteractive />
      <AIAssistant />
      <IntegrationOptions />
      <WhyDangol />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/reach" element={<Reach />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/privacy-partners" element={<PrivacyPartners />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/terms-partners" element={<TermsPartners />} />
        <Route path="/customersupport" element={<Support />} />
        <Route path="/links" element={<Links />} />
      </Routes>
    </Router>
  );
}

export default App;
